import { FormularioOrtodontia } from '../vo/formulario-ortodontia';

export class ItensDiagnosticoComplementar {

    static getItensDiagnostico(formularioOrtodontia: FormularioOrtodontia){
        return [
            { nome: 'Biprotrusão', detalhe: '', visivel: formularioOrtodontia.biprotrusao },
            { nome: 'Apinhamento', detalhe: formularioOrtodontia.txtApinhamento, visivel: formularioOrtodontia.apinhamento },
            { nome: 'Diastemas', detalhe: formularioOrtodontia.txtDiastemas, visivel: formularioOrtodontia.diastemas },
            { nome: 'Mordida Aberta', detalhe: formularioOrtodontia.txtMordidaAberta, visivel: formularioOrtodontia.mordidaAberta },
            { nome: 'Mordida Cruzada', detalhe: formularioOrtodontia.txtMordidaCruzada, visivel: formularioOrtodontia.mordidaCruzada },
            { nome: 'Mordida Profunda (Overbite)', detalhe: '', visivel: formularioOrtodontia.mordidaProfunda },
            { nome: 'Sobressaliência (Overjet)', detalhe: '', visivel: formularioOrtodontia.sobresaliencia },
            { nome: 'Outros', detalhe: formularioOrtodontia.txtDiagnosticoOutros, visivel: formularioOrtodontia.diagnosticoOutros }
        ];
    }
}


// WEBPACK FOOTER //
// ./src/app/components/base/util/itens-diagnostico-complementar.ts